import { authHeader, handleResponse } from '../helpers';
export const CategoryService = {
    createCategory,
    updateCategory,
    getCategoryData,
    inActiveRow
};

function createCategory(data) {
    console.log(data)
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}TicketMst/NewTicket`, requestOptions)
        .then(handleResponse);
}

function updateCategory(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}TicketMst/add-reply`, requestOptions)
        .then(handleResponse);
}

function getCategoryData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/GetDetails`, requestOptions)
        .then(handleResponse);
}

async function inActiveRow(categoryId, isActive) { 
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}CategoryMaster/CreateUpdateCategory/${categoryId}/${isActive}`, requestOptions)
        .then(handleResponse);
}


